import { createContext, useContext } from 'react'

export type SidebarControls = {
  isCollapsed: boolean
  isExpanded: boolean
  toggleCollapsed: () => void
  toggleExpanded: () => void
  shrink: () => void
}

const noop = () => undefined

export const COLLAPSED_SIDEBAR_CONTROL_WIDTH = 72

export const SidebarControlsContext = createContext<SidebarControls>({
  isCollapsed: false,
  isExpanded: false,
  toggleCollapsed: noop,
  toggleExpanded: noop,
  shrink: noop,
})

export const useSidebarControls = () => useContext(SidebarControlsContext)
